// var PIXI = require('pixi.js');

var majorVersion = parseInt(PIXI.VERSION.split(".")[0], 10);

if (majorVersion < 5) {
  throw new Error(("Detected Pixi.js version " + (PIXI.VERSION) + ". pixi-multistyle-text supports Pixi.js version 5+. (Please use v0.8.0 for Pixi 4 support.)"));
}

var INTERACTION_EVENTS = ["pointerover", "pointerenter", "pointerdown", "pointermove", "pointerup", "pointercancel", "pointerout", "pointerleave", "gotpointercapture", "lostpointercapture", "mouseover", "mouseenter", "mousedown", "mousemove", "mouseup", "mousecancel", "mouseout", "mouseleave", "touchover", "touchenter", "touchdown", "touchmove", "touchup", "touchcancel", "touchout", "touchleave"];
var TAG_STYLE = {
  bbcode: "bbcode",
  xml: "xml"
};
var TAG = {
  bbcode: ["[", "]"],
  xml: ["<", ">"]
};
var MultiStyleText = /*@__PURE__*/(function (superclass) {
  function MultiStyleText(text, styles) {
    var this$1 = this;

    superclass.call(this, text);
    this.styles = styles;
    INTERACTION_EVENTS.forEach(function (event) {
      this$1.on(event, function (e) { return this$1.handleInteraction(e); });
    });
  }

  if ( superclass ) MultiStyleText.__proto__ = superclass;
  MultiStyleText.prototype = Object.create( superclass && superclass.prototype );
  MultiStyleText.prototype.constructor = MultiStyleText;

  var prototypeAccessors = { styles: { configurable: true } };

  MultiStyleText.prototype.handleInteraction = function handleInteraction (e) {
    var ev = e;
    var localPoint = e.data.getLocalPosition(this);
    var targetTag = this.hitboxes.reduce(function (prev, hitbox) { return prev !== undefined ? prev : hitbox.hitbox.contains(localPoint.x, localPoint.y) ? hitbox : undefined; }, undefined);
    ev.targetTag = targetTag === undefined ? undefined : targetTag.tag;
  };

  prototypeAccessors.styles.set = function (styles) {
    this.textStyles = {};
    this.textStyles["default"] = this.assign({}, MultiStyleText.DEFAULT_TAG_STYLE);

    for (var style in styles) {
      if (style === "default") {
        this.assign(this.textStyles["default"], styles[style]);
      } else {
        this.textStyles[style] = this.assign({}, styles[style]);
      }
    }

    if (this.textStyles.default.tagStyle === TAG_STYLE.bbcode) {
      this.textStyles.b = this.assign({}, {
        fontStyle: 'bold'
      });
      this.textStyles.i = this.assign({}, {
        fontStyle: 'italic'
      });
      this.textStyles.color = this.assign({}, {
        fill: ''
      });
      this.textStyles.outline = this.assign({}, {
        stroke: '',
        strokeThickness: 6
      });
      this.textStyles.font = this.assign({}, {
        fontFamily: ''
      });
      this.textStyles.shadow = this.assign({}, {
        dropShadowColor: '',
        dropShadow: true,
        dropShadowBlur: 3,
        dropShadowDistance: 3,
        dropShadowAngle: 2
      });
      this.textStyles.size = this.assign({}, {
        fontSize: 'px'
      });
      this.textStyles.spacing = this.assign({}, {
        letterSpacing: ''
      });
      this.textStyles.align = this.assign({}, {
        align: ''
      });
    }

    this.withPrivateMembers()._style = new PIXI.TextStyle(this.textStyles["default"]);
    this.withPrivateMembers().dirty = true;
  };

  MultiStyleText.prototype.setTagStyle = function setTagStyle (tag, style) {
    if (tag in this.textStyles) {
      this.assign(this.textStyles[tag], style);
    } else {
      this.textStyles[tag] = this.assign({}, style);
    }

    this.withPrivateMembers()._style = new PIXI.TextStyle(this.textStyles["default"]);
    this.withPrivateMembers().dirty = true;
  };

  MultiStyleText.prototype.deleteTagStyle = function deleteTagStyle (tag) {
    if (tag === "default") {
      this.textStyles["default"] = this.assign({}, MultiStyleText.DEFAULT_TAG_STYLE);
    } else {
      delete this.textStyles[tag];
    }

    this.withPrivateMembers()._style = new PIXI.TextStyle(this.textStyles["default"]);
    this.withPrivateMembers().dirty = true;
  };

  MultiStyleText.prototype.getTagRegex = function getTagRegex (captureName, captureMatch) {
    var tagAlternation = Object.keys(this.textStyles).join("|");
    var ref = this.textStyles.default;
    var tagStyle = ref.tagStyle;

    if (captureName) {
      tagAlternation = "(" + tagAlternation + ")";
    } else {
      tagAlternation = "(?:" + tagAlternation + ")";
    }

    var reStr = tagStyle === TAG_STYLE.bbcode ? ("\\" + (TAG.bbcode[0]) + tagAlternation + "(?:\\=(?:[A-Za-z0-9_\\-\\#]+|'(?:[^']+|\\\\')*'))*\\s*\\" + (TAG.bbcode[1]) + "|\\" + (TAG.bbcode[0]) + "\\/" + tagAlternation + "\\s*\\" + (TAG.bbcode[1])) : ("\\" + (TAG.xml[0]) + tagAlternation + "(?:\\s+[A-Za-z0-9_\\-]+=(?:\"(?:[^\"]+|\\\\\")*\"|'(?:[^']+|\\\\')*'))*\\s*\\" + (TAG.xml[1]) + "|\\" + (TAG.xml[0]) + "\\/" + tagAlternation + "\\s*\\" + (TAG.xml[1]));

    if (captureMatch) {
      reStr = "(" + reStr + ")";
    }

    return new RegExp(reStr, "g");
  };

  MultiStyleText.prototype.getPropertyRegex = function getPropertyRegex () {
    return new RegExp("([A-Za-z0-9_\\-]+)=(?:\"((?:[^\"]+|\\\\\")*)\"|'((?:[^']+|\\\\')*)')", "g");
  };

  MultiStyleText.prototype.getBBcodePropertyRegex = function getBBcodePropertyRegex () {
    return new RegExp("[A-Za-z0-9_\\-]+=([A-Za-z0-9_\\-\\#]+)", "g");
  };

  MultiStyleText.prototype._getTextDataPerLine = function _getTextDataPerLine (lines) {
    var outputTextData = [];
    var re = this.getTagRegex(true, false);
    var styleStack = [this.assign({}, this.textStyles["default"])];
    var tagStack = [{
      name: "default",
      properties: {}
    }];

    for (var i = 0; i < lines.length; i++) {
      var lineTextData = [];
      var matches = [];
      var matchArray = (void 0);

      while (matchArray = re.exec(lines[i])) {
        matches.push(matchArray);
      }

      if (matches.length === 0) {
        lineTextData.push(this.createTextData(lines[i], styleStack[styleStack.length - 1], tagStack[tagStack.length - 1]));
      } else {
        var currentSearchIdx = 0;

        for (var j = 0; j < matches.length; j++) {
          if (matches[j].index > currentSearchIdx) {
            lineTextData.push(this.createTextData(lines[i].substring(currentSearchIdx, matches[j].index), styleStack[styleStack.length - 1], tagStack[tagStack.length - 1]));
          }

          if (matches[j][0][1] === "/") {
            if (styleStack.length > 1) {
              styleStack.pop();
              tagStack.pop();
            }
          } else {
            var properties = {};
            var propertyRegex = this.getPropertyRegex();
            var propertyMatch = (void 0);

            while (propertyMatch = propertyRegex.exec(matches[j][0])) {
              properties[propertyMatch[1]] = propertyMatch[2] || propertyMatch[3];
            }

            tagStack.push({
              name: matches[j][1],
              properties: properties
            });
            var ref = this.textStyles.default;
            var tagStyle$1 = ref.tagStyle;

            if (tagStyle$1 === TAG_STYLE.bbcode && matches[j][0].includes('=') && this.textStyles[matches[j][1]]) {
              var bbcodeRegex = this.getBBcodePropertyRegex();
              var bbcodeTags = bbcodeRegex.exec(matches[j][0]);
              var bbStyle = {};
              Object.entries(this.textStyles[matches[j][1]]).forEach(function (style) {
                bbStyle[style[0]] = typeof style[1] !== 'string' ? style[1] : bbcodeTags[1] + style[1];
              });
              styleStack.push(this.assign({}, styleStack[styleStack.length - 1], bbStyle));
            } else {
              styleStack.push(this.assign({}, styleStack[styleStack.length - 1], this.textStyles[matches[j][1]]));
            }
          }

          currentSearchIdx = matches[j].index + matches[j][0].length;
        }

        if (currentSearchIdx < lines[i].length) {
          var result = this.createTextData(currentSearchIdx ? lines[i].substring(currentSearchIdx) : lines[i], styleStack[styleStack.length - 1], tagStack[tagStack.length - 1]);
          lineTextData.push(result);
        }
      }

      outputTextData.push(lineTextData);
    }

    var ref$1 = this.textStyles.default;
    var tagStyle = ref$1.tagStyle;
    outputTextData[outputTextData.length - 1].map(function (data) {
      if (data.text.includes(TAG[tagStyle][0])) { data.text = data.text.match(tagStyle === TAG_STYLE.bbcode ? /^(.*)\[/ : /^(.*)\</)[1]; }
    });
    return outputTextData;
  };

  MultiStyleText.prototype.getFontString = function getFontString (style) {
    return new PIXI.TextStyle(style).toFontString();
  };

  MultiStyleText.prototype.createTextData = function createTextData (text, style, tag) {
    return {
      text: text,
      style: style,
      width: 0,
      height: 0,
      fontProperties: undefined,
      tag: tag
    };
  };

  MultiStyleText.prototype.getDropShadowPadding = function getDropShadowPadding () {
    var this$1 = this;

    var maxDistance = 0;
    var maxBlur = 0;
    Object.keys(this.textStyles).forEach(function (styleKey) {
      var ref = this$1.textStyles[styleKey];
      var dropShadowDistance = ref.dropShadowDistance;
      var dropShadowBlur = ref.dropShadowBlur;
      maxDistance = Math.max(maxDistance, dropShadowDistance || 0);
      maxBlur = Math.max(maxBlur, dropShadowBlur || 0);
    });
    return maxDistance + maxBlur;
  };

  MultiStyleText.prototype.withPrivateMembers = function withPrivateMembers () {
    return this;
  };

  MultiStyleText.prototype.updateText = function updateText () {
    var this$1 = this;

    if (!this.withPrivateMembers().dirty) {
      return;
    }

    this.hitboxes = [];
    this.texture.baseTexture.resolution = this.resolution;
    var textStyles = this.textStyles;
    var outputText = this.text;

    if (this.withPrivateMembers()._style.wordWrap) {
      outputText = this.wordWrap(this.text);
    }

    var lines = outputText.split(/(?:\r\n|\r|\n)/);

    var outputTextData = this._getTextDataPerLine(lines);

    var lineWidths = [];
    var lineYMins = [];
    var lineYMaxs = [];
    var maxLineWidth = 0;

    for (var i = 0; i < lines.length; i++) {
      var lineWidth = 0;
      var lineYMin = 0;
      var lineYMax = 0;

      for (var j = 0; j < outputTextData[i].length; j++) {
        var sty = outputTextData[i][j].style;
        this.context.font = this.getFontString(sty);
        outputTextData[i][j].width = this.context.measureText(outputTextData[i][j].text).width;

        if (outputTextData[i][j].text.length !== 0) {
          outputTextData[i][j].width += (outputTextData[i][j].text.length - 1) * sty.letterSpacing;

          if (j > 0) {
            lineWidth += sty.letterSpacing / 2;
          }

          if (j < outputTextData[i].length - 1) {
            lineWidth += sty.letterSpacing / 2;
          }
        }

        lineWidth += outputTextData[i][j].width;
        outputTextData[i][j].fontProperties = PIXI.TextMetrics.measureFont(this.context.font);
        outputTextData[i][j].height = outputTextData[i][j].fontProperties.fontSize;

        if (typeof sty.valign === "number") {
          lineYMin = Math.min(lineYMin, sty.valign - outputTextData[i][j].fontProperties.descent);
          lineYMax = Math.max(lineYMax, sty.valign + outputTextData[i][j].fontProperties.ascent);
        } else {
          lineYMin = Math.min(lineYMin, -outputTextData[i][j].fontProperties.descent);
          lineYMax = Math.max(lineYMax, outputTextData[i][j].fontProperties.ascent);
        }
      }

      lineWidths[i] = lineWidth;
      lineYMins[i] = lineYMin;
      lineYMaxs[i] = lineYMax;
      maxLineWidth = Math.max(maxLineWidth, lineWidth);
    }

    var stylesArray = Object.keys(textStyles).map(function (key) { return textStyles[key]; });
    var maxStrokeThickness = stylesArray.reduce(function (prev, cur) { return Math.max(prev, cur.strokeThickness || 0); }, 0);
    var dropShadowPadding = this.getDropShadowPadding();
    var totalHeight = lineYMaxs.reduce(function (prev, cur) { return prev + cur; }, 0) - lineYMins.reduce(function (prev, cur) { return prev + cur; }, 0);
    var width = maxLineWidth + 2 * maxStrokeThickness + 2 * dropShadowPadding;
    var height = totalHeight + 2 * maxStrokeThickness + 2 * dropShadowPadding;
    this.canvas.width = width * this.resolution;
    this.canvas.height = height * this.resolution;
    this.context.scale(this.resolution, this.resolution);
    this.context.textBaseline = "alphabetic";
    this.context.lineJoin = "round";
    var basePositionY = dropShadowPadding + maxStrokeThickness;
    var drawingData = [];

    for (var i$1 = 0; i$1 < outputTextData.length; i$1++) {
      var line = outputTextData[i$1];
      var linePositionX = (void 0);

      switch (this.withPrivateMembers()._style.align) {
        case "left":
          linePositionX = dropShadowPadding + maxStrokeThickness;
          break;

        case "center":
          linePositionX = dropShadowPadding + maxStrokeThickness + (maxLineWidth - lineWidths[i$1]) / 2;
          break;

        case "right":
          linePositionX = dropShadowPadding + maxStrokeThickness + maxLineWidth - lineWidths[i$1];
          break;
      }

      for (var j$1 = 0; j$1 < line.length; j$1++) {
        var ref = line[j$1];
        var style = ref.style;
        var text = ref.text;
        var fontProperties = ref.fontProperties;
        var width$1 = ref.width;
        var tag = ref.tag;
        var linePositionY = basePositionY + fontProperties.ascent;

        switch (style.valign) {
          case "top":
            break;

          case "baseline":
            linePositionY += lineYMaxs[i$1] - fontProperties.ascent;
            break;

          case "middle":
            linePositionY += (lineYMaxs[i$1] - lineYMins[i$1] - fontProperties.ascent - fontProperties.descent) / 2;
            break;

          case "bottom":
            linePositionY += lineYMaxs[i$1] - lineYMins[i$1] - fontProperties.ascent - fontProperties.descent;
            break;

          default:
            linePositionY += lineYMaxs[i$1] - fontProperties.ascent - style.valign;
            break;
        }

        if (style.letterSpacing === 0) {
          drawingData.push({
            text: text,
            style: style,
            x: linePositionX,
            y: linePositionY,
            width: width$1,
            ascent: fontProperties.ascent,
            descent: fontProperties.descent,
            tag: tag
          });
          linePositionX += line[j$1].width;
        } else {
          this.context.font = this.getFontString(line[j$1].style);

          for (var k = 0; k < text.length; k++) {
            if (k > 0 || j$1 > 0) {
              linePositionX += style.letterSpacing / 2;
            }

            var charWidth = this.context.measureText(text.charAt(k)).width;
            drawingData.push({
              text: text.charAt(k),
              style: style,
              x: linePositionX,
              y: linePositionY,
              width: charWidth,
              ascent: fontProperties.ascent,
              descent: fontProperties.descent,
              tag: tag
            });
            linePositionX += charWidth;

            if (k < text.length - 1 || j$1 < line.length - 1) {
              linePositionX += style.letterSpacing / 2;
            }
          }
        }
      }

      basePositionY += lineYMaxs[i$1] - lineYMins[i$1];
    }

    this.context.save();
    drawingData.forEach(function (ref) {
      var style = ref.style;
      var text = ref.text;
      var x = ref.x;
      var y = ref.y;

      if (!style.dropShadow) {
        return;
      }

      this$1.context.font = this$1.getFontString(style);
      var dropFillStyle = style.dropShadowColor;

      if (typeof dropFillStyle === "number") {
        dropFillStyle = PIXI.utils.hex2string(dropFillStyle);
      }

      this$1.context.shadowColor = dropFillStyle;
      this$1.context.shadowBlur = style.dropShadowBlur;
      this$1.context.shadowOffsetX = Math.cos(style.dropShadowAngle) * style.dropShadowDistance * this$1.resolution;
      this$1.context.shadowOffsetY = Math.sin(style.dropShadowAngle) * style.dropShadowDistance * this$1.resolution;
      this$1.context.fillText(text, x, y);
    });
    this.context.restore();
    drawingData.forEach(function (ref) {
      var style = ref.style;
      var text = ref.text;
      var x = ref.x;
      var y = ref.y;

      if (style.stroke === undefined || !style.strokeThickness) {
        return;
      }

      this$1.context.font = this$1.getFontString(style);
      var strokeStyle = style.stroke;

      if (typeof strokeStyle === "number") {
        strokeStyle = PIXI.utils.hex2string(strokeStyle);
      }

      this$1.context.strokeStyle = strokeStyle;
      this$1.context.lineWidth = style.strokeThickness;
      this$1.context.strokeText(text, x, y);
    });
    drawingData.forEach(function (ref) {
      var style = ref.style;
      var text = ref.text;
      var x = ref.x;
      var y = ref.y;

      if (style.fill === undefined) {
        return;
      }

      this$1.context.font = this$1.getFontString(style);
      var fillStyle = style.fill;

      if (typeof fillStyle === "number") {
        fillStyle = PIXI.utils.hex2string(fillStyle);
      } else if (Array.isArray(fillStyle)) {
        for (var i = 0; i < fillStyle.length; i++) {
          var fill = fillStyle[i];

          if (typeof fill === "number") {
            fillStyle[i] = PIXI.utils.hex2string(fill);
          }
        }
      }

      this$1.context.fillStyle = this$1._generateFillStyle(new PIXI.TextStyle(style), [text]);
      this$1.context.fillText(text, x, y);
    });
    drawingData.forEach(function (ref) {
      var style = ref.style;
      var x = ref.x;
      var y = ref.y;
      var width = ref.width;
      var ascent = ref.ascent;
      var descent = ref.descent;
      var tag = ref.tag;

      var offset = -this$1.withPrivateMembers()._style.padding - this$1.getDropShadowPadding();
      this$1.hitboxes.push({
        tag: tag,
        hitbox: new PIXI.Rectangle(x + offset, y - ascent + offset, width, ascent + descent)
      });
      var debugSpan = style.debug === undefined ? MultiStyleText.debugOptions.spans.enabled : style.debug;

      if (debugSpan) {
        this$1.context.lineWidth = 1;

        if (MultiStyleText.debugOptions.spans.bounding) {
          this$1.context.fillStyle = MultiStyleText.debugOptions.spans.bounding;
          this$1.context.strokeStyle = MultiStyleText.debugOptions.spans.bounding;
          this$1.context.beginPath();
          this$1.context.rect(x, y - ascent, width, ascent + descent);
          this$1.context.fill();
          this$1.context.stroke();
          this$1.context.stroke();
        }

        if (MultiStyleText.debugOptions.spans.baseline) {
          this$1.context.strokeStyle = MultiStyleText.debugOptions.spans.baseline;
          this$1.context.beginPath();
          this$1.context.moveTo(x, y);
          this$1.context.lineTo(x + width, y);
          this$1.context.closePath();
          this$1.context.stroke();
        }

        if (MultiStyleText.debugOptions.spans.top) {
          this$1.context.strokeStyle = MultiStyleText.debugOptions.spans.top;
          this$1.context.beginPath();
          this$1.context.moveTo(x, y - ascent);
          this$1.context.lineTo(x + width, y - ascent);
          this$1.context.closePath();
          this$1.context.stroke();
        }

        if (MultiStyleText.debugOptions.spans.bottom) {
          this$1.context.strokeStyle = MultiStyleText.debugOptions.spans.bottom;
          this$1.context.beginPath();
          this$1.context.moveTo(x, y + descent);
          this$1.context.lineTo(x + width, y + descent);
          this$1.context.closePath();
          this$1.context.stroke();
        }

        if (MultiStyleText.debugOptions.spans.text) {
          this$1.context.fillStyle = "#ffffff";
          this$1.context.strokeStyle = "#000000";
          this$1.context.lineWidth = 2;
          this$1.context.font = "8px monospace";
          this$1.context.strokeText(tag.name, x, y - ascent + 8);
          this$1.context.fillText(tag.name, x, y - ascent + 8);
          this$1.context.strokeText(((width.toFixed(2)) + "x" + ((ascent + descent).toFixed(2))), x, y - ascent + 16);
          this$1.context.fillText(((width.toFixed(2)) + "x" + ((ascent + descent).toFixed(2))), x, y - ascent + 16);
        }
      }
    });

    if (MultiStyleText.debugOptions.objects.enabled) {
      if (MultiStyleText.debugOptions.objects.bounding) {
        this.context.fillStyle = MultiStyleText.debugOptions.objects.bounding;
        this.context.beginPath();
        this.context.rect(0, 0, width, height);
        this.context.fill();
      }

      if (MultiStyleText.debugOptions.objects.text) {
        this.context.fillStyle = "#ffffff";
        this.context.strokeStyle = "#000000";
        this.context.lineWidth = 2;
        this.context.font = "8px monospace";
        this.context.strokeText(((width.toFixed(2)) + "x" + (height.toFixed(2))), 0, 8, width);
        this.context.fillText(((width.toFixed(2)) + "x" + (height.toFixed(2))), 0, 8, width);
      }
    }

    this.updateTexture();
  };

  MultiStyleText.prototype.wordWrap = function wordWrap (text) {
    var result = "";
    var re = this.getTagRegex(true, true);
    var lines = text.split("\n");

    var wordWrapWidth = this.withPrivateMembers()._style.wordWrapWidth;

    var styleStack = [this.assign({}, this.textStyles["default"])];
    this.context.font = this.getFontString(this.textStyles["default"]);

    for (var i = 0; i < lines.length; i++) {
      var spaceLeft = wordWrapWidth;
      var tagSplit = lines[i].split(re);
      var firstWordOfLine = true;

      for (var j = 0; j < tagSplit.length; j++) {
        if (re.test(tagSplit[j])) {
          result += tagSplit[j];

          if (tagSplit[j][1] === "/") {
            j += 2;
            styleStack.pop();
          } else {
            j++;
            styleStack.push(this.assign({}, styleStack[styleStack.length - 1], this.textStyles[tagSplit[j]]));
            j++;
          }

          this.context.font = this.getFontString(styleStack[styleStack.length - 1]);
        } else {
          var words = tagSplit[j].split(" ");

          for (var k = 0; k < words.length; k++) {
            var wordWidth = this.context.measureText(words[k]).width;

            if (this.withPrivateMembers()._style.breakWords && wordWidth > spaceLeft) {
              var characters = words[k].split('');

              if (k > 0) {
                result += " ";
                spaceLeft -= this.context.measureText(" ").width;
              }

              for (var c = 0; c < characters.length; c++) {
                var characterWidth = this.context.measureText(characters[c]).width;

                if (characterWidth > spaceLeft) {
                  result += "\n" + (characters[c]);
                  spaceLeft = wordWrapWidth - characterWidth;
                } else {
                  result += characters[c];
                  spaceLeft -= characterWidth;
                }
              }
            } else if (this.withPrivateMembers()._style.breakWords) {
              result += words[k];
              spaceLeft -= wordWidth;
            } else {
              var paddedWordWidth = wordWidth + (k > 0 ? this.context.measureText(" ").width : 0);

              if (paddedWordWidth > spaceLeft) {
                if (!firstWordOfLine) {
                  result += "\n";
                }

                result += words[k];
                spaceLeft = wordWrapWidth - wordWidth;
              } else {
                spaceLeft -= paddedWordWidth;

                if (k > 0) {
                  result += " ";
                }

                result += words[k];
              }
            }

            firstWordOfLine = false;
          }
        }
      }

      if (i < lines.length - 1) {
        result += '\n';
      }
    }

    return result;
  };

  MultiStyleText.prototype.updateTexture = function updateTexture () {
    var texture = this.withPrivateMembers()._texture;

    var dropShadowPadding = this.getDropShadowPadding();
    texture.baseTexture.setRealSize(this.canvas.width, this.canvas.height, this.resolution);
    texture.trim.width = texture.frame.width = this.canvas.width / this.resolution;
    texture.trim.height = texture.frame.height = this.canvas.height / this.resolution;
    texture.trim.x = -this.withPrivateMembers()._style.padding - dropShadowPadding;
    texture.trim.y = -this.withPrivateMembers()._style.padding - dropShadowPadding;
    texture.orig.width = texture.frame.width - (this.withPrivateMembers()._style.padding + dropShadowPadding) * 2;
    texture.orig.height = texture.frame.height - (this.withPrivateMembers()._style.padding + dropShadowPadding) * 2;

    this.withPrivateMembers()._onTextureUpdate();

    texture.baseTexture.emit('update', texture.baseTexture);
    this.withPrivateMembers().dirty = false;
  };

  MultiStyleText.prototype.assign = function assign (destination) {
    var sources = [], len = arguments.length - 1;
    while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];

    for (var i = 0, list = sources; i < list.length; i += 1) {
      var source = list[i];

      for (var key in source) {
        destination[key] = source[key];
      }
    }

    return destination;
  };

  Object.defineProperties( MultiStyleText.prototype, prototypeAccessors );

  return MultiStyleText;
}(PIXI.Text));
MultiStyleText.DEFAULT_TAG_STYLE = {
  align: "left",
  breakWords: false,
  dropShadow: false,
  dropShadowAngle: Math.PI / 6,
  dropShadowBlur: 0,
  dropShadowColor: "#000000",
  dropShadowDistance: 5,
  fill: "black",
  fillGradientType: PIXI.TEXT_GRADIENT.LINEAR_VERTICAL,
  fontFamily: "Arial",
  fontSize: 26,
  fontStyle: "normal",
  fontVariant: "normal",
  fontWeight: "normal",
  letterSpacing: 0,
  lineHeight: 0,
  lineJoin: "miter",
  miterLimit: 10,
  padding: 0,
  stroke: "black",
  strokeThickness: 0,
  textBaseline: "alphabetic",
  valign: "baseline",
  wordWrap: false,
  wordWrapWidth: 100,
  tagStyle: "xml"
};
MultiStyleText.debugOptions = {
  spans: {
    enabled: false,
    baseline: "#44BB44",
    top: "#BB4444",
    bottom: "#4444BB",
    bounding: "rgba(255, 255, 255, 0.1)",
    text: true
  },
  objects: {
    enabled: false,
    bounding: "rgba(255, 255, 255, 0.05)",
    text: true
  }
};

module.exports = MultiStyleText;
//# sourceMappingURL=pixi-multistyle-text.js.map
